<template>
  <div class="stationInfo" v-if="isShow">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('预约信息')" />
    <div class="box">
      <div class="infoBox">
        <div class="title">
          {{ this.data.workAreaName }}
          {{
            this.data.stationSigns &&
            this.data.stationSigns[0] &&
            this.data.stationSigns[0].stationInfo.stationName
          }}
        </div> 
        <div class="time">
          <div>{{ $t('开始时间：') }}</div>
          <div>{{ this.getYear(this.data.startTime) }}</div>
          <div>{{ this.getWeek(this.data.startTime) }}</div>
          <div>
            {{
              this.getTime(
                this.configureInfo['make-setting'].mixMakeDay,
                this.data.startTime
              )
            }}
          </div>
        </div>
        <div class="time">
          <div>{{ $t('结束时间：') }}</div>
          <div>{{ this.getYear(this.data.endTime) }}</div>
          <div>{{ this.getWeek(this.data.endTime) }}</div>
          <div>
            {{
              this.getTime(
                this.configureInfo['make-setting'].mixMakeDay,
                this.data.endTime
              )
            }}
          </div>
        </div>
        <div class="person">
          <div>{{ $t('预约人：') }}</div>
          <div>{{ this.info.staffInfo.name }}</div>
        </div>

        <div
          v-if="
            this.info.signState === 'NOT_SING_IN' &&
            this.info.statusAttribute !== 'FINISHED'
          "
        >
          <div
            v-if="
              (!this.configureInfo['make-setting'].isSign &&
                !dayjs().isBefore(dayjs(this.data.startTime))) ||
              (this.configureInfo['make-setting'].isSign &&
                !dayjs().isBefore(dayjs(this.data.startTime)) &&
                canYouSignIn(this.configureInfo['make-setting'], this.data) !==
                  'SIGNIN')
            "
            class="displayEarlyButton"
            @click.stop="endEarly()"
          >
            {{ $t('提前结束') }}
          </div>
          <div
            class="tips"
            v-if="
              this.configureInfo['make-setting'].isSign &&
              !this.configureInfo['make-setting'].isH5Sign &&
              canYouSignIn(this.configureInfo['make-setting'], this.data) ===
                'SIGNIN' &&
              this.type !== 'qrcode'
            "
          >
            {{ $t('请扫描桌面二维码签到') }}
          </div>
          <div
            v-if="
              dayjs().isBefore(dayjs(this.data.startTime)) ||
              (this.configureInfo['make-setting'].isSign &&
                canYouSignIn(this.configureInfo['make-setting'], this.data) ===
                  'SIGNIN')
            "
            class="displayEarlyButton"
            @click.stop="onStartCancel()"
          >
            {{ $t('取消预约') }}
          </div>
          <div
            class="displayEarlyButton"
            v-if="
              this.configureInfo['make-setting'].isSign &&
              (this.configureInfo['make-setting'].isH5Sign || this.type == 'qrcode') &&
              canYouSignIn(this.configureInfo['make-setting'], this.data) ===
              'SIGNIN'
            "
            @click.stop="onOK()"
          >
             {{ $t('签到') }}
          </div>
        </div>
        <div
          v-if="
            this.info.signState === 'SING_IN' &&
            this.info.statusAttribute !== 'FINISHED'
          "
        >
          <div
            v-if="this.info.statusAttribute === 'IN_USE'"
            class="displayEarlyButton"
            @click.stop="endEarly()"
          >
            {{ $t('提前结束') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import {
  reservationInfo,
  reservationInfoCode,
  updateAppointmentStatus,
  earlyTermination,
} from '@/services/api'
import moment from 'moment'
import { Toast } from 'vant'
import dayjs from 'dayjs'

export default {
  name: 'myStatstationInfoion',
  components: {
    NavBar,
  },
  data() {
    console.log(this.$route.query)
    return {
      sourceIsH5: true,
      stationId: this.$route.query.stationId,
      makeState: this.$route.query.makeState || 'ALL_MAKE_STATE',
      companyCode: this.$route.query.companyCode
        ? this.$route.query.companyCode
        : undefined,
      token: this.$route.query.token ? this.$route.query.token : undefined,
      type: this.$route.query.type ? this.$route.query.type : undefined,
      data: {},
      info: {
        staffInfo: {},
      },
      user: {},
      configureInfo: {
        'make-setting': {},
      },
      displayEarlyButton: true,
      isShow: false,
    }
  },
  methods: {
    async fetchApi(params) {
      let res
      if (params.token && params.companyCode) {
        res = await reservationInfoCode(params.id, params.makeState)
      } else {
        res = await reservationInfo(params.id, params.makeState)
      }
      const data = res.data
      if (data) {
        data.startTime = moment(data.startTime).toISOString()
        data.endTime = moment(data.endTime).toISOString()
      }
      this.data = data
      for (const item of data.stationSigns && data.stationSigns) {
        if (item.subscriberId == this.user.id) {
          this.info = item
          this.isShow = true
        } else {
          this.isShow = false
          Toast(this.$t('这不是您预约的工位'))
          this.$router.push('/')
          // window.location.href =
          //   'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0NjQyMzM0NQ==&scene=124#wechat_redirect'
        }
      }
      this.configureInfo = JSON.parse(this.info.confHistoryInfo)
    },

    getWeek(date) {
      // 参数时间戳
      let week = moment(date).day()
      switch (week) {
        case 1:
          return this.$t('周一')
        case 2:
          return this.$t('周二')
        case 3:
          return this.$t('周三')
        case 4:
          return this.$t('周四')
        case 5:
          return this.$t('周五')
        case 6:
          return this.$t('周六')
        case 0:
          return this.$t('周日')
      }
    },
    getTimeDate(value) {
      return moment(value).calendar(null, {
        sameDay: this.$t('[今天]'),
        nextDay: this.$t('[明天]'),
        nextWeek: this.$t('[明天和以后]'),
        lastDay: this.$t('[昨天]'),
        lastWeek: this.$t('[上周]'),
        sameElse: this.$t('[一周以后]'),
      })
    },
    async onOK() {
      const data = await updateAppointmentStatus({
        stationSignId: this.info.id,
        state: 'YES',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.fetchApi({ id: this.info.id, makeState: this.makeState })
        Toast(this.$t('签到成功'))
      } else {
        Toast(this.$t('此时间段不可签到！'))
      }
    },
    async endEarly() {
      const res = await earlyTermination({
        companyId: this.user.companyId,
        userId: this.user.id,
        stationSignId: this.info.id,
      })
      if (res.code === 200) {
        this.fetchApi({ id: this.info.id, makeState: this.makeState })
        Toast(`${res.msg}`)
      } else {
        Toast(`${res.msg}`)
      }
    },
    async onStartCancel() {
      const data = await updateAppointmentStatus({
        stationSignId: this.info.id,
        state: 'NO',
        userId: this.user.id,
      })
      if (data.code === 200) {
        this.fetchApi({ id: this.info.id, makeState: this.makeState })
        Toast(this.$t('取消成功！'))
      } else {
        Toast(this.$t('此时间段不可取消预约！'))
      }
    },

    canYouSignIn(configureInfo, value) {
      console.log('canYouSignIn', configureInfo, value)
      //当预约时间段是天
      const createdTimeToDay = moment().isSame(moment(value.createdTime), 'day') //创建时间是否为今天
      const startTimeToDay = moment().isSame(moment(value.startTime), 'day') //预约时间是否为今天
      // if (configureInfo.mixMakeDay == 'DAY') {
      //   const isMorning = dayjs().hour() < 12 //当前时间是否为上午
      //   const createdTimeIsMorning = dayjs(value.createdTime).hour() < 12 //创建时间是否为上午
      //   const signDate =
      //     dayjs() <
      //     dayjs(value.createdTime).hour(dayjs(value.createdTime).hour() + 2) //当天下午预约，可签到时间为创建时间后两小时之内，当前时间是否处于可签到时间范围
      //   //非当天预约的情况下，签到截止的时间为12点
      //   if (!createdTimeToDay && startTimeToDay && isMorning) {
      //     return 'SIGNIN'
      //   }
      //   //当天上午预约。签到截止时间为12点
      //   if (
      //     createdTimeToDay &&
      //     startTimeToDay &&
      //     createdTimeIsMorning &&
      //     isMorning
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   //当天下午预约，签到时间为创建时间后两个小时以内
      //   if (
      //     createdTimeToDay &&
      //     startTimeToDay &&
      //     !createdTimeIsMorning &&
      //     signDate
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   return 'NOT_SIGNIN'
      // }

      //当预约时间段是半天
      // if (configureInfo.mixMakeDay == 'HALF_A_DAY') {
      //   const beforeNine =
      //     dayjs(value.createdTime) < dayjs().hour(9).minute(0).second(0) //创建时间是否在当天九点之前
      //   const beforeThirteen =
      //     dayjs().hour(13).minute(0).second(0) > dayjs(value.createdTime) &&
      //     dayjs(value.createdTime) > dayjs().hour(12).minute(0).second(0) //创建时间是否在当天的12点后13点前
      //   const afternine =
      //     dayjs(value.createdTime) >= dayjs().hour(9).minute(0).second(0) &&
      //     dayjs(value.endTime).hour() === 12 //当天九点之后预约的上午
      //   const afterThirteen =
      //     dayjs(value.createdTime) >= dayjs().hour(13).minute(0).second(0) &&
      //     dayjs(value.endTime).hour() === 23 //当天十三点之后预约的下午
      //   if (configureInfo.isRelease) {
      //     //当天上午九点钟之前预约，签到范围在九点加配置的分钟
      //     if (
      //       beforeNine &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs().hour(9).minute(configureInfo.releaseTime).second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //下午十三点前预约，签到范围在十三点点加配置的分钟
      //     if (
      //       beforeThirteen &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs().hour(13).minute(configureInfo.releaseTime).second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //上午九点钟之后预约上午，签到范围在创建时间加配置的分钟
      //     if (
      //       afternine &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs(value.createdTime)
      //           .minute(
      //             dayjs(value.createdTime).minute() +
      //               (configureInfo.releaseTime - 0)
      //           )
      //           .second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     //上午九点钟之后预约上午，签到范围在创建时间加配置的分钟
      //     if (
      //       afterThirteen &&
      //       startTimeToDay &&
      //       dayjs() <
      //         dayjs(value.createdTime)
      //           .minute(
      //             dayjs(value.createdTime).minute() +
      //               (configureInfo.releaseTime - 0)
      //           )
      //           .second(0)
      //     ) {
      //       return 'SIGNIN'
      //     }
      //     return 'NOT_SIGNIN'
      //   }
      // } else {
      //   if (
      //     dayjs() >= dayjs(value.startTime) &&
      //     dayjs() < dayjs(value.endTime)
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   return 'NOT_SIGNIN'
      // }

      //当预约时间段为小时/半小时
      if (
        configureInfo.mixMakeDay == 'HALF_A_HOUR' ||
        configureInfo.mixMakeDay == 'HOURS' ||
        configureInfo.mixMakeDay == 'CUSTOM_TIME' ||
        configureInfo.mixMakeDay == 'DAY'
      ) {
        const beforeCreatedTime =
          dayjs(value.createdTime) < dayjs(value.startTime) //创建时间在预约时间段之前
        const afterTime = dayjs(value.createdTime) >= dayjs(value.startTime) //创建时间在预约时间段之前
        if (configureInfo.isRelease) {
          if (
            beforeCreatedTime &&
            startTimeToDay &&
            dayjs() >= dayjs(value.startTime) &&
            dayjs(value.startTime)
              .minute(
                dayjs(value.startTime).minute() +
                  (configureInfo?.releaseTime ?? 0 - 0)
              )
              .second(0) > dayjs()
          ) {
            return 'SIGNIN'
          }
          if (
            afterTime &&
            startTimeToDay &&
            dayjs() <
              dayjs(value.createdTime)
                .minute(
                  dayjs(value.createdTime).minute() +
                    (configureInfo?.releaseTime ?? 0 - 0)
                )
                .second(0)
          ) {
            return 'SIGNIN'
          }
        } else {
          if (
            dayjs() >= dayjs(value.startTime) &&
            dayjs() < dayjs(value.endTime)
          ) {
            return 'SIGNIN'
          }
          return 'NOT_SIGNIN'
        }
        return 'NOT_SIGNIN'
      }
      // else {
      //   if (
      //     dayjs() >= dayjs(value.startTime) &&
      //     dayjs() < dayjs(value.endTime)
      //   ) {
      //     return 'SIGNIN'
      //   }
      //   return 'NOT_SIGNIN'
      // }
    },
    ExtensionOfTime(value, releaseTime) {
      const event = new Date(value)
      const min = event.getMinutes()
      return event.setMinutes(min + (releaseTime - 0))
    },
    getTime(mixMakeDay, time) {
      if (mixMakeDay == 'HALF_A_DAY') {
        if (new Date(time).getHours() >= 0 && new Date(time).getHours() < 12) {
          return this.$t('上半天')
        } else if (
          new Date(time).getHours() >= 12 &&
          new Date(time).getHours() <= 23
        ) {
          return this.$t('下半天')
        }
      } else {
        return moment(time).format('HH:mm')
      }
    },
    getYear(time) {
      return moment(time).format(this.$t('YYYY年MM-DD'))
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.fetchApi({
      id: this.stationId,
      companyCode: this.companyCode,
      token: this.token,
      makeState: this.makeState,
    })
  },
}
</script>
<style lang="less" scoped>
.box {
  background-color: #f5f5f5;
  height: 100vh;
  padding-top: 8px;
}
.infoBox {
  width: 342px;
  padding-top: 13px;
  padding-bottom: 9px;
  padding-left: 16px;
  background-color: #fefffe;
  border-radius: 6px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  margin: auto;
}
.title {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  margin-bottom: 10px;
}
.time {
  display: flex;
  margin-bottom: 4px;
}
.time div:first-child {
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.time div:nth-child(2) {
  height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-left: 5px;
}
.time div:nth-child(3) {
  height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-left: 5px;
  margin-right: 12px;
}
.time div:last-child {
  height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.person {
  display: flex;
}
.person div:first-child {
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.person div:last-child {
  height: 24px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-left: 14px;
}
.button {
  width: 300px;
  height: 44px;
  background: #009bff;
  border-radius: 24px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  margin-top: 13px;
}
.tips {
  width: 250px;
  height: 24px;
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #009bff;
  line-height: 24px;
  margin-top: 13px;
  margin-bottom: 13px;
  text-align: center;
  margin: auto;
}
.displayEarlyButton {
  width: 300px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #009bff;
  border-radius: 24px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #009bff;
  line-height: 44px;
  text-align: center;
  margin-top: 13px;
}
.button_box {
  width: 300px;
  height: 44px;
  display: flex;
  justify-content: space-between;
  margin-top: 13px;
}
.button_box_SignIn {
  width: 145px;
  height: 44px;
  background: #009bff;
  border-radius: 24px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
}
.button_box_Cancel {
  width: 145px;
  height: 44px;
  background: #ffffff;
  border-radius: 24px;
  font-size: 16px;
  border: 1px solid #009bff;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #009bff;
  line-height: 44px;
  text-align: center;
}
</style>
